/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {FC, useEffect, useMemo, useState} from 'react'
import {TabCentralModel} from '../../../../../../models'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useCentral} from '../../../../../../hooks/useCentral'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {ClaimUserModelDocument} from '../../../../model/claimUser.model'
import {getClaims} from '../../../../services/claimUser.service'
import {formatDateDDMMYYYY} from '../../../../../../util/dates'
import {getMasterService} from '../../../../services'
import {useAuth} from '../../../../../../hooks/useAuth'

const TableClaimUser: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    clearSelected,
    pagination,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    setClearTable,
  } = useKTable()
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useCentral()
  const {applications} = useAuth()
  const mappedSites = applications.map((item: any) => ({
    value: item.aplicacionId,
    label: item.description,
  }))

  const {searchValues, clearSearchValues} = useKhipu()
  const [typeRequirement, setTypeRequirement] = useState<any>([])
  const [statusRequirement, setStatusRequirement] = useState<any>([])
  const [typeDocument, setTypeDocument] = useState<any>([])
  const [typeClaimant, setTypeClaimant] = useState<any>([])

  const getStatusRequirementList = async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 2000))
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'EstadoRequerimiento',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setStatusRequirement(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  const getTypeRequirementList = async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 2000))
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoRequerimiento',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setTypeRequirement(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  const getTypeClaimantList = async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 2000))
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'Reclamante',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setTypeClaimant(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  const getTypeDocumentList = async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 2000))
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoDocumento',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
      }))
      setTypeDocument(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  const getClaimList = async () => {
    try {
      setLoading(true)
      const {data: response} = await getClaims(searchValues, pagination.currentPage)
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }
  useEffect(() => {
    getStatusRequirementList()
    getTypeRequirementList()
    getTypeClaimantList()
    getTypeDocumentList()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    getClaimList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])
  useEffect(() => {
    if (Object.keys(searchValues).length === 0) {
      getClaimList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValues])
  const handleViewPanel = (data: any) => {
    const getRow = data.row
    const getArrows = data.data
    const getData = getArrows[getRow.index]
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: true,
      content: {
        ...currentTabItem.content,
        detailPanel: 'tab-claim-user',
      },
      idToEdit: getData.Id,
      idToDelete: '',
    }
    clearSelected()
    changeCurrentTabItem(obj)
  }

  const columns: Column<ClaimUserModelDocument>[] = useMemo(
    () => [
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Número de Requerimiento'
            name='nroRequerimiento'
            searcheable
          />
        ),
        accessor: 'nroRequerimiento',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha de Requerimiento'
            name='fechaRequerimiento'
            dateable
          />
        ),
        accessor: 'fechaRequerimiento',
        Cell: ({...props}) => (
          <div>{formatDateDDMMYYYY(props.row.original.fechaRequerimiento)}</div>
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de Requerimiento'
            name='tipoRequerimientoId'
            data={typeRequirement}
            selecteable
          />
        ),
        accessor: 'tipoRequerimientoNombre',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Módulo de Requerimiento'
            name='aplicacionId'
            data={mappedSites}
            selecteable
          />
        ),
        accessor: 'aplicacion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Reclamante'
            name='reclamanteId'
            data={typeClaimant}
            selecteable
          />
        ),
        accessor: 'reclamanteNombre',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nombres' name='usuarioNombres' searcheable />
        ),
        accessor: 'usuarioNombres',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de Documento'
            name='usuarioTipoDoc'
            data={typeDocument}
            selecteable
          />
        ),
        accessor: 'usuarioTipoDocNombre',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nro de Documento'
            name='usuarioNroDoc'
            searcheable
          />
        ),
        accessor: 'usuarioNroDoc',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estado de Requerimiento'
            name='estadoRequerimiento'
            data={statusRequirement}
            selecteable
          />
        ),
        accessor: 'estadoRequerimientoNombre',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <>
            {isAllowed('EDITAR') && (
              <div
                className='d-flex justify-content-center flex-shrink-0'
                onClick={() => handleViewPanel(props)}
              >
                <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
                </a>
              </div>
            )}{' '}
          </>
        ),
      },
    ],
    [typeClaimant, typeDocument, statusRequirement, typeRequirement, selectedOn],
  )

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {}, [data])

  useEffect(() => {
    if (currentTabItem.loadingTable) {
      clearSelected()
      getClaimList()
    }
  }, [currentTabItem.loadingTable])
  useEffect(() => {
    if (updateTable) {
      clearSelected()
      getClaimList()
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])

  useEffect(() => {
    if (clearTable) {
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])
  return (
    <>
      {isAllowed('LISTAR') && (
        <KTCard shadow className='mx-2  w-100'>
          <KTable data={data} columns={columns} classNameProps='dataTablecentral' />

          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCard>
      )}
    </>
  )
}

const TableClaimUserWrapper = () => {
  return (
    <KTableProvider>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Listado de Requerimientos</Tab>
          </TabList>
          <TabPanel>
            <TableClaimUser />
          </TabPanel>
        </Tabs>
      </div>
    </KTableProvider>
  )
}

export {TableClaimUserWrapper}
